"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getTabsTransforms = function (activeButton) {
    if (!activeButton)
        return {};
    var style = getComputedStyle(activeButton);
    return {
        width: style.width,
        left: "".concat(activeButton.offsetLeft, "px"),
    };
};
exports.default = getTabsTransforms;
